<template>
  <div class="compare-surveys-container">
    <template>
      <div class="d-flex justify-content-around">
        <div
          v-for="(id, index) in compareSurveysIds"
          :key="'survey' + id"
          :style="{ width: `${100 / compareSurveysIds.length - 1}%` }"
          class="individual-survey"
        >
          <survey-red-for-compare
            v-if="surveyType == 'red'"
            :id="id"
            :index="index"
          />
          <survey-yes-for-compare v-else :id="id" :index="index" />
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import SurveyRedForCompare from "./survey-red-for-compare.vue";
import SurveyYesForCompare from "./survey-yes-for-compare.vue";

export default {
  name: "CompareSurveysUnDemographic",
  components: {
    SurveyRedForCompare,
    SurveyYesForCompare,
  },
  computed: {
    compareSurveysIds() {
      return this.$route.query.surveyId;
    },
    surveyType() {
      return this.$route.query.type;
    },
  },
  destroyed() {
    this.$store.dispatch("mainStats/resetCompareData");
  },
};
</script>

<style lang="scss" scoped>
.compare-surveys-container {
  height: calc(100vh - 6.25rem);
  overflow: auto;
}
::-webkit-scrollbar {
  width: 0;
}
.individual-survey {
  max-width: 37.5rem;
}
</style>
